import { render, staticRenderFns } from "./VisaoGeralInternacao.vue?vue&type=template&id=6d95f13e&"
import script from "./VisaoGeralInternacao.vue?vue&type=script&lang=js&"
export * from "./VisaoGeralInternacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports